import { environment } from 'services/apiConfigs';

export default (desired_dimensions, folder_name, file_name) => {
  const cdn_url = 'https://d2jefos38oys06.cloudfront.net/fit-in';
  return `${cdn_url}/${desired_dimensions}/${environment}/${
    folder_name ? folder_name + '/' : ''
  }${file_name}`;
};



// WEBPACK FOOTER //
// ./src/app/services/amazonAWS/getImageOnS3.js